import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
          width={40}
          height={40}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <rect width={40} height={40} rx={20} fill={theme["#B4E3E1"]} />
          <g clipPath="url(#clip0_4065_9071)">
            <path
              d="M15.079 19.355A6.675 6.675 0 0115 18.33c0-3.682 3.005-6.667 6.71-6.667 3.707 0 6.711 2.985 6.711 6.667 0 .832-.153 1.628-.433 2.362-.058.152-.087.229-.1.288a.75.75 0 00-.02.16c-.002.062.007.129.023.263l.336 2.726c.036.294.054.442.005.55a.417.417 0 01-.214.209c-.108.046-.256.025-.55-.018l-2.654-.39c-.139-.02-.208-.03-.271-.03a.742.742 0 00-.167.018c-.062.013-.14.043-.298.102a6.735 6.735 0 01-3.392.35m-4.326 3.41c2.47 0 4.474-2.052 4.474-4.584 0-2.53-2.003-4.583-4.474-4.583-2.47 0-4.474 2.052-4.474 4.583 0 .51.081.999.23 1.456.064.193.095.29.106.356.01.069.012.108.008.177-.004.067-.02.142-.054.293l-.509 2.302 2.496-.341a2.04 2.04 0 01.264-.028c.062 0 .095.004.157.017.058.011.145.042.318.103a4.37 4.37 0 001.458.249z"
              stroke={theme["#0D968F"]}
              strokeWidth={1.66667}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_4065_9071">
              <path fill="#fff" transform="translate(10 10)" d="M0 0H20V20H0z" />
            </clipPath>
          </defs>
        </svg>
    )
}
  
  export default SvgComponent